import { render, staticRenderFns } from "./PersonVacationList.vue?vue&type=template&id=71e77b4a&"
import script from "./PersonVacationList.vue?vue&type=script&lang=js&"
export * from "./PersonVacationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports